<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    // this.showToastMask()
    this.wxShare({
      title: '北京冰球运动协会',
      link: window.location.href,
      image: 'http://static.bjh.snsports.cn/FruhsWyiCMvAfRAJlNmkj8oSem0j?imageView2/1/w/128/h/128',
      abstract: '会员管理系统'
    })
  },
  methods: {
    showToastMask () {
      const toast = this.$createToast({
        txt: '努力加载中...',
        mask: true
      })
      toast.show()
    }
  }
}
</script>

<style lang="stylus">
body
  background-color white
body,html
  height: 100%
.clearfix:after
  content: "020"
  display: block
  height: 0
  clear: both
  visibility: hidden
.clearfix
  zoom: 1;

#app
  height: 100%
  max-width 768px; /*px*/
  margin 0 auto;
</style>



// WEBPACK FOOTER //
// src/App.vue